// src/components/BuySteps/PaymentWidgetStep.js
import React, { useState, useEffect } from 'react';
import { useUser } from '../../contexts/UserContext';
import { startBuyOrder } from '../../services/proptService';

const PaymentWidgetStep = ({ rateData, setCurrentStep, cryptoType, setRateData }) => {
     const [widgetUrl, setWidgetUrl] = useState(null);
     const [isLoading, setIsLoading] = useState(false);
     const [error, setError] = useState('');
     const { userData } = useUser();

     const paymentId = rateData?.payment_id;
     const userWallets = userData?.user?.wallets;

     useEffect(() => {
          if (!paymentId || !userWallets || userWallets.length === 0) {
               return;
          }

          let isMounted = true;

          const generateOrder = async () => {
               if (isMounted) {
                    setIsLoading(true);
                    setError('');
                    setWidgetUrl(null);
               }

               try {
                    console.log("2. StartBuyOrder -> Usando esta lista de wallets:", userData.user.wallets);
                    let targetWalletCurrency = '';
                    if (cryptoType?.name?.includes('Ethereum')) {
                         targetWalletCurrency = 'PROPT-ETH';
                    } else if (cryptoType?.name?.includes('Polygon')) {
                         targetWalletCurrency = 'PROPT-POL';
                    }
                    if (!targetWalletCurrency) throw new Error("Could not determine the PROPT network for the transaction.");

                    const proptWallet = userWallets.find(w => w.currency === targetWalletCurrency);
                    if (!proptWallet || !proptWallet.address) throw new Error(`Valid PROPT wallet not found for the ${targetWalletCurrency} network. Maybe due to older account`);

                    const params = {
                         invoice_amount: parseFloat(rateData.invoice_amount),
                         currency: cryptoType.currency,
                         // currency: rateData.currency,
                         invoice_currency: rateData.invoice_currency,
                         address: proptWallet.address,
                         payment_id: paymentId,
                    };

                    console.log("2. StartBuyOrder -> Enviando Params:", params);
                    const orderData = await startBuyOrder(params);

                    console.log(orderData);
                    if (orderData && orderData.err) {
                         console.error("API returned a success status but with an error payload:", orderData.err);
                         // 2. Si la hay, lanzamos un error con un mensaje amigable para el usuario.
                         throw new Error("The payment service is currently busy due to high traffic. Please wait a moment and try again.");
                    }

                    if (isMounted) {
                         setRateData(orderData);
                         if (orderData?.widget_url) {
                              setWidgetUrl(orderData.widget_url);
                         } else {
                              // Este error ahora solo se mostrará si la API da una respuesta válida pero sin la URL
                              console.log("Valid response but missing widget_url:", orderData);
                              throw new Error("An unexpected error occurred. The payment widget URL was not received.");
                         }
                    }

               } catch (err) {
                    console.error("Error generating payment order:", err);
                    if (isMounted) setError(err.message || "Could not generate payment order. Please try again.");
               } finally {
                    if (isMounted) setIsLoading(false);
               }
          };

          generateOrder();

          return () => { isMounted = false; };
     }, [paymentId, userData, cryptoType, setRateData]);

     if (!paymentId || !userWallets || userWallets.length === 0) {
          let reason = "unknown issue";
          if (!paymentId) {
               reason = "transaction ID";
          } else if (!userData) {
               reason = "user data (context is null)";
          } else if (!userWallets) {
               reason = "user wallets (property does not exist)";
          } else if (userWallets.length === 0) {
               reason = "user wallets (list is empty)";
          }

          return <div className="modal_content_body text-center"><h4>Preparing payment details... (Waiting for {reason})</h4></div>;
     }

     if (isLoading) {
          return <div className="modal_content_body text-center"><h4>Generating secure payment order...</h4></div>;
     }

     if (error) {
          return (
               <div className="modal_content_body text-center">
                    <h4 className="text-danger">Error</h4>
                    <p>{error}</p>
               </div>
          );
     }

     return (
          <div className="modal_content_body text-center">
               <h3 className="ppt_form_title mb-4">Complete Your Payment</h3>
               <p>Please complete your payment in the secure window below.</p>
               {widgetUrl && (
                    <iframe
                         src={widgetUrl}
                         title="Payment Widget"
                         style={{ width: '100%', height: '500px', border: '1px solid #ccc', borderRadius: '8px' }}
                    />
               )}

               <small
                    className="t-anchor mt-4 d-block pointer"
                    onClick={() => setCurrentStep(4)}
               >
                    [view "I have sent the payment, check status" screen]
               </small>
               {/* 
               <button
                    className="ppt_btn_primary alt mt-4"
                    onClick={() => setCurrentStep(4)}
               >
                    I have sent the payment, check status
               </button> */}
          </div>
     );
};

export default PaymentWidgetStep;